"use client";

import { useEffect } from "react";

export default function FontLoader({ font }: { font?: string | null }) {
  useEffect(() => {
    if (!font) return;
    const family = String(font).trim();
    if (!family) return;

    // Build Google Fonts URL. Allow comma-separated fallback fonts but only use first for Google API.
    const primary = family.split(",")[0].trim();
    const familyForUrl = primary.replace(/\s+/g, "+");
    const href = `https://fonts.googleapis.com/css2?family=${encodeURIComponent(familyForUrl)}:wght@400;700&display=swap`;

    // Avoid duplicate link tags
    if (Array.from(document.head.querySelectorAll("link[rel=stylesheet]"))
      .some((l) => l.getAttribute("data-font-loader-href") === href || (l as HTMLLinkElement).href === href)) {
      return;
    }

    const link = document.createElement("link");
    link.rel = "stylesheet";
    link.href = href;
    link.setAttribute("data-font-loader-href", href);
    document.head.appendChild(link);

    return () => {
      // Keep the font link for page lifetime to avoid flashes.
    };
  }, [font]);

  return null;
}
